/**
 * Footer bar for the Schedule Interview wizard.
 * Back / Cancel / Primary action buttons + optional secondary CTA.
 */
import { Box } from '@chakra-ui/react';
import { WizardFooter } from '../../components/WizardFooter';

interface ScheduleFooterProps {
  disabled: boolean;
  canGoBack: boolean;
  backButtonLabel: string;
  primaryButtonLabel: string;
  onBack: () => void;
  onCancel: () => void;
  onPrimary: () => void;
  secondaryCta?: { label: string; onClick: () => void };
}

export const ScheduleFooter = ({
  disabled,
  canGoBack,
  backButtonLabel,
  primaryButtonLabel,
  onBack,
  onCancel,
  onPrimary,
  secondaryCta,
}: ScheduleFooterProps) => (
  <Box
    flexShrink={0}
    borderTop="1px solid"
    borderColor="border-color"
    px="4"
    py="3"
  >
    <WizardFooter
      disabled={disabled}
      canGoBack={canGoBack}
      backButtonLabel={backButtonLabel}
      primaryButtonLabel={primaryButtonLabel}
      onBack={onBack}
      onCancel={onCancel}
      onPrimary={onPrimary}
      secondaryCta={secondaryCta}
    />
  </Box>
);
